import React from 'react';
import OverlayLoading from '../../../../../../Components/OverlayLoading';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../../../../../Components/Loading';
import ManagerInsuranceCompaniesBatchesTable from '../ManagerInsuranceCompaniesBatchesTable/ManagerInsuranceCompaniesBatchesTable';
import {
	InsuranceCompanyBatch,
	InsuranceCompanyBatchesDefaultColumns,
	InsuranceCompanyBatchesTable,
} from '../../../../Consts/InsuranceCompanyBatchesDefaultColumns.const';
import styles from './ManagerInsuranceCompaniesBatchesList.module.scss';

const WRAPPER_ID = 'insuranceCompaniesBatches';

interface Props {
	isLoading?: boolean;
	data: InsuranceCompanyBatch[];
	onRefresh: () => void;
	onLoadMore: () => void;
	hasMoreData: boolean;
	table?: InsuranceCompanyBatchesTable;
}

const ManagerInsuranceCompaniesBatchesList = ({
	isLoading,
	data,
	onRefresh,
	onLoadMore,
	hasMoreData,
	table,
}: Props) => {
	return (
		<div className={styles.wrapper}>
			{isLoading && <OverlayLoading />}
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<InfiniteScroll
					dataLength={data.length}
					refreshFunction={onRefresh}
					next={onLoadMore}
					hasMore={hasMoreData}
					loader={<Loading />}
					scrollableTarget={WRAPPER_ID}>
					<ManagerInsuranceCompaniesBatchesTable
						data={data}
						columns={InsuranceCompanyBatchesDefaultColumns}
						table={table}
					/>
				</InfiniteScroll>
			</ScrollContainer>
		</div>
	);
};

export default ManagerInsuranceCompaniesBatchesList;
